import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { colorScheme } from '../../theme';

interface Props {
  size: number;
  values: number[];
  labels: string[];
}

export function Histogram(props: Props) {
  const [histogramMax, setHistogramMax] = useState<number>(1);

  useEffect(() => {
    setHistogramMax(Math.max(...props.values));
  }, [props.values]);

  const { labels, size } = props;
  const ticks = labels.length;

  const getTickPosition = (index: number) => {
    const absolutePosition = (index * 100) / ticks;
    const barStartsEvery = 100 / size;

    const res = Math.round(absolutePosition / barStartsEvery) * barStartsEvery;

    return `${res}%`;
  };

  return (
    <HistogramContainer>
      {labels.map((l, idx) => (
        <label key={idx} style={{ left: getTickPosition(idx) }}>
          {l}
        </label>
      ))}

      {props.values.map((value: number, idx: number) => (
        <BarContainer key={idx}>
          <Bar
            style={{
              height: `${(value * 100) / histogramMax}%`,
              transitionDelay: `${idx * 25}ms`,
            }}
          />
        </BarContainer>
      ))}
    </HistogramContainer>
  );
}

const HistogramContainer = styled.div`
  height: 200px;
  width: 100%;
  border-bottom: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
  position: relative;
  top: 0;
  display: flex;

  label {
    padding-left: 0.5em;
    position: absolute;
    top: 0;
    height: 100%;
    transition: 300ms ease left;
    border-left: 1px solid #d8d8d8;
    font-size: 14px;
    font-weight: 800;
    color: #7e7e7e;
  }
`;

const BarContainer = styled.div`
  flex: 1;
  position: relative;
  top: 0;
  margin: 0 5px;
`;

const Bar = styled.div`
  width: 100%;
  border-radius: 5px;
  background: ${colorScheme.brand};
  position: absolute;
  bottom: 0;
  height: 0;
  transition: 300ms ease height;
`;
